/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentStatusEnum } from './document-status-enum';

export interface DeckStatusChangeSelfPublishFile {
  readonly id: string;
  readonly file: string | null;
  readonly name: string | null;
  readonly type: string;
  readonly description: string | null;
  readonly status: DocumentStatusEnum;
  readonly rejection_reason: string | null;
}
export namespace DeckStatusChangeSelfPublishFile {}
